// GAVION call-brief-pipeline (spec A5): the brief shown before a call, under the call in the lead's history, collapsed.
import { useTranslate } from "ra-core";
import { briefOfMeta } from "./callBriefModel";

export const TimelineBriefBlock = ({ brief }: { brief: unknown }) => {
  const t = useTranslate();
  const b = briefOfMeta(brief);
  if (!b) return null;
  return (
    <details className="text-sm">
      <summary className="cursor-pointer self-start text-muted-foreground">
        {t("gavion.call_brief.timeline.title")}
      </summary>
      <dl className="mt-1 grid gap-1 sm:grid-cols-[max-content_1fr] sm:gap-x-3">
        <dt className="font-medium text-muted-foreground">
          {t("gavion.call_brief.card.what_they_do")}
        </dt>
        <dd>{b.whatTheyDo}</dd>
        <dt className="font-medium text-muted-foreground">
          {t("gavion.call_brief.card.hook")}
        </dt>
        <dd>{b.hook}</dd>
      </dl>
    </details>
  );
};
